export class Regex{
    static EmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    static lower =  /(?=.*[a-z])/
    static upper = /(?=.*[A-Z])/    
    static number = /(?=.*[0-9])/
    static special = /(?=.*[!@#\$%\^&\*])/
    static PassLength = /(?=.{8,})/
    static Otp = /^\d{6}$/
}